/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from 'ngx-bootstrap/modal/modal-container.component';
import * as import2 from 'ngx-bootstrap/modal/modal-options.class';
import * as import3 from 'ngx-bootstrap/modal/bs-modal.service';
const styles_ModalContainerComponent:any[] = ([] as any[]);
export const RenderType_ModalContainerComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ModalContainerComponent,
  data: {}
}
);
export function View_ModalContainerComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',[[
        'role',
        'document'
      ]
      ],[[
        8,
        'className',
        0
      ]
    ],(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n      '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),1,'div',[[
        'class',
        'modal-content'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    import0.ɵncd((null as any),0),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n  ']))
  ]
  ,(null as any),(ck,v) => {
    var co:import1.ModalContainerComponent = v.component;
    const currVal_0:any = ('modal-dialog' + (co.config.class? (' ' + co.config.class): ''));
    ck(v,1,0,currVal_0);
  });
}
function View_ModalContainerComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'modal-container',[
      [
        'class',
        'modal'
      ]
      ,
      [
        'role',
        'dialog'
      ]
      ,
      [
        'tabindex',
        '-1'
      ]

    ]
    ,(null as any),[
      [
        (null as any),
        'click'
      ]
      ,
      [
        'window',
        'keydown.esc'
      ]

    ]
    ,(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,1).onClick($event)) !== false);
        ad = (pd_0 && ad);
      }
      if (('window:keydown.esc' === en)) {
        const pd_1:any = ((<any>import0.ɵnov(v,1).onEsc()) !== false);
        ad = (pd_1 && ad);
      }
      return ad;
    },View_ModalContainerComponent_0,RenderType_ModalContainerComponent)),
    import0.ɵdid(122880,(null as any),0,import1.ModalContainerComponent,[
      import2.ModalOptions,
      import0.ElementRef,
      import3.BsModalService,
      import0.Renderer
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ModalContainerComponentNgFactory:import0.ComponentFactory<import1.ModalContainerComponent> = import0.ɵccf('modal-container',import1.ModalContainerComponent,View_ModalContainerComponent_Host_0,{},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3NyYy9ub2RlX21vZHVsZXMvbmd4LWJvb3RzdHJhcC9tb2RhbC9tb2RhbC1jb250YWluZXIuY29tcG9uZW50LmQudHMiLCJuZzovLy9zcmMvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLk1vZGFsQ29udGFpbmVyQ29tcG9uZW50Lmh0bWwiLCJuZzovLy9zcmMvbm9kZV9tb2R1bGVzL25neC1ib290c3RyYXAvbW9kYWwvbW9kYWwtY29udGFpbmVyLmNvbXBvbmVudC5kLnRzLk1vZGFsQ29udGFpbmVyQ29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiXG4gICAgPGRpdiBbY2xhc3NdPVwiJ21vZGFsLWRpYWxvZycgKyAoY29uZmlnLmNsYXNzID8gJyAnICsgY29uZmlnLmNsYXNzIDogJycpXCIgcm9sZT1cImRvY3VtZW50XCI+XG4gICAgICA8ZGl2IGNsYXNzPVwibW9kYWwtY29udGVudFwiPjxuZy1jb250ZW50PjwvbmctY29udGVudD48L2Rpdj5cbiAgICA8L2Rpdj5cbiAgIiwiPG1vZGFsLWNvbnRhaW5lcj48L21vZGFsLWNvbnRhaW5lcj4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7SUNBQTtNQUNJO1FBQUE7UUFBQTtNQUFBO01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTtJQUFBO0lBQXlGO01BQ3ZGO1FBQUE7UUFBQTtNQUFBO0lBQUE7Z0JBQTJCO0lBQStCO0lBQ3REOzs7O0lBRkQ7SUFBTCxTQUFLLFNBQUw7Ozs7O0lDREo7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7TUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtLQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO01BQUE7UUFBQTtRQUFBO01BQUE7TUFBQTtRQUFBO1FBQUE7TUFBQTtNQUFBO0lBQUE7Z0JBQUE7Ozs7O0lBQUE7S0FBQTs7O0lBQUE7OzsifQ==



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src?&aot=true&genDir=compiled!./~/tslint-loader!./compiled/~/ngx-bootstrap/modal/modal-container.component.ngfactory.ts